import styled from 'styled-components';

export const CategoryBlock = styled.div`
  display: block;
  padding: 0 16px;
  border-bottom: 1px solid #dfe1e6;
  padding-bottom: 16px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 0;
`;

export const Link = styled.a`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 8px 0;
  &:last-child {
    margin-bottom: 0;
  }
  & svg {
    margin-right: 8px;
  }
`;

export const Panel = styled.div`
  overflow: hidden;
`;

export const SocialNetworks = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 37px;
`;

export const IconLink = styled.a`
  display: block;
  margin: 0 12px;
`;

export const Apps = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Copyright = styled.div`
  width: 100%;
  margin-top: 36px;
  padding: 0 16px;
  border-top: 1px solid #c8c8d4;
`;

export const CurrencySelectorWrapper = styled.div`
  margin-top: 32px;
`;

export const Details = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
